"use strict";

exports.__esModule = true;
exports.scaleElement = scaleElement;
var _excluded = ["width", "height"];
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Scale a layout element to a given width / height.
 */
function scaleElement(element, newWidth, newHeight) {
  if (element.type !== "Surface" && element.type !== "Dashboard" && element.type !== "OperatorPanel") {
    return element;
  }
  var _element$props = element.props,
    width = _element$props.width,
    height = _element$props.height,
    extra = _objectWithoutPropertiesLoose(_element$props, _excluded);
  if (typeof width !== "number" || typeof height !== "number" || width === newWidth && height === newHeight) {
    return element;
  }
  var props = Object.assign({}, extra, {
    width: newWidth,
    height: newHeight
  });
  var children = [];
  for (var _iterator = _createForOfIteratorHelperLoose(element.children), _step; !(_step = _iterator()).done;) {
    var child = _step.value;
    var _child$props = child.props,
      childX = _child$props.x,
      childY = _child$props.y,
      childWidth = _child$props.width,
      childHeight = _child$props.height;
    var childProps = Object.assign({}, child.props);
    var isRightAligned = childX + childWidth >= width;
    var isBottomAligned = childY + childHeight >= height;
    var availableWidth = newWidth - childX;
    var availableHeight = newHeight - childY;
    if (newWidth < width) {
      if (availableWidth < 32) {
        children.push(child);
        continue;
      }
    }
    if (newWidth > width && isRightAligned) {
      childProps.width = availableWidth;
    }
    if (newHeight > height && isBottomAligned) {
      childProps.height = availableHeight;
    }
    children.push({
      type: child.type,
      props: childProps,
      children: child.children
    });
  }
  return {
    type: element.type,
    props: props,
    children: children
  };
}